export const RouterPaths = {
  NOTES: 'notatki',
  TODO: 'do-zrobienia',
  CALENDAR_DATE: 'kalendarz/:date',
  CALENDAR: 'kalendarz',
  CALENDAR_BIRTHDAYS: 'kalendarz/cykliczne',
  DOCS: 'dokumenty',
  DOCS_SINGLE: 'dokumenty/:id',
};
